const DisplayNamePrefix = "MSFT";
export { DisplayNamePrefix };
